import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#pricing'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const sharedClassName = `relative overflow-hidden group bg-brand-green text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-3 w-full max-w-md mx-auto cursor-pointer no-underline ${className}`;
  const innerContent = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-29">
        {children}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-30" />
      </span>
      <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-31"></div>
      <div className="absolute inset-0 rounded-full border-2 border-brand-green animate-ping opacity-20" data-id="element-32"></div>
    </>;
  if (href) {
    return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={sharedClassName} data-id="element-33">
        {innerContent}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={sharedClassName} data-id="element-34">
      {innerContent}
    </motion.button>;
}